



















import { Vue, Component, Prop } from 'vue-property-decorator';
import CloseIcon from 'mdi-vue/CloseThick';

import { removeToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

@Component({
  components: {
    CloseIcon,
  },
})
export default class Toast extends Vue {
  @Prop(String) type!: ToastType;
  @Prop(String) id!: string;
  @Prop(String) title!: string;
  @Prop(String) message!: string;

  timeoutId = 0;

  mounted() {
    this.timeoutId = window.setTimeout(() => {
      this.close();
    }, 5000);
  }

  close() {
    clearTimeout(this.timeoutId);
    removeToast(this.id);
  }

  get image() {
    const images = require.context('@/assets/', false, /\.png$/);

    switch (this.type) {
      case ToastType.SUCCESS:
        return images('./toast-success.png');
      case ToastType.FAILED:
        return images('./toast-failed.png');
      default:
        return '';
    }
  }
}
